import { SiteErrorsView as SiteErrorsContentView } from '../DevOps/SiteErrors/SiteErrorsView'
import { PageContainer } from './PageContainer'

export const SiteErrorsView = () => (
  <PageContainer>
    <SiteErrorsContentView />
  </PageContainer>
)
